// eslint-disable-next-line import/no-extraneous-dependencies
import getWebAppRouteKey from './getWebAppRouteKey';

export default function getSanitizedWebappRoute(path: string): string | null {
  const cleanPath = path.replace(/\/(fr|en)\//, '/').split('?')[0];

  if (getWebAppRouteKey(cleanPath)) {
    return cleanPath ?? null;
  }
  return null;
}
